import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default {
  __name: 'index',
  setup(__props) {
    const pagemain = computed(() => {
      const route = useRoute();
      let folder = route.params.root || 'home';
      folder = folder.toLowerCase();
      let filename = route.params.sub || folder;
      if (folder == 'course' || folder == 'uwe') {
        filename = folder;
      }
      return defineAsyncComponent(() => import('@/views/' + folder + '/' + filename + ".vue"));
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_resolveDynamicComponent(_unref(pagemain)), _toHandlers(_ctx.$attrs), null, 16);
    };
  }
};